module.exports = __webpack_public_path__ + "banner-bg.4ff54186be6c04273613.jpg";